/**
 * inCust API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface CustomerAccountTransferFundsRequestApiModel {
  /**
   * Operation amount
   */
  amount: number;
  /**
   * Recipient of funds User identifier (phone number, email, external identifier)
   */
  recipient_id: string;
  /**
   * Type of recipient user identity (optional)
   */
  recipient_id_type?: CustomerAccountTransferFundsRequestApiModelRecipientIdTypeEnum | null;
  /**
   * Special Account ID
   */
  special_account_id: string | null;
}
export enum CustomerAccountTransferFundsRequestApiModelRecipientIdTypeEnum {
  Phone = 'phone',
  Email = 'email',
  ExternalId = 'external-id',
  Qr = 'qr'
}
